import $ from 'jquery';

import appeals from './Appeals.directive';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider: any) {
  if (
    document.location.pathname === '/appeals' &&
    (!document.location.hash || document.location.hash === '#/')
  ) {
    document.location.hash = 'appeals';
  }

  $stateProvider
    .state('appeals', {
      url: '/appeals',
      template: `<div ${appeals.htmlName}></div>`,
    })
    .state('appeals.unitpopup', {
      url: '/unit/:id',
      // views: {
      //   drawer: {
      //     template: () => `<div ${unitContainer.htmlName}></div>`,
      //   },
      // },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    })
    .state('appeals.leadpopup', {
      url: '/lead/:id',
      // views: {
      //   drawer: {
      //     template: () => `<div ${leadContainer.htmlName}></div>`,
      //   },
      // },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    });
}
